import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import GetInTouchFooter from "./GetInTouchFooter";
import openMouthImg from "../assets/openMouth.svg";
import girlBookImg from "../assets/girlwithbook.svg";
import { useLocation } from "react-router-dom";
import Who from "./About/Who";
import Vision from "./About/Vision";
import Mission from "./About/Mission";
import Leader from "./About/Leader";
import MeetTeam from "./About/MeetTeam";
import OurStory from "./About/OurStory";
import Awards from "./About/Awards";
import CustomFaqs from "./custom/CustomFaqs";
import Groups from "./About/Groups";
import headingImg from "../assets/openMouth.svg";
import headingImg2 from "../assets/headingImg2.svg";
import headingIm3 from "../assets/headingImg3.svg";
import headingImg4 from "../assets/HeadingImg4.svg";
import CustomHeading from "./custom/CustomHeading";
import yearsImg from "../assets/30-years-legacy.jpg";
import awardsImg from "../assets/100+-Awards.jpg";
import winningImg from "../assets/Award-winning-curriculum-2.jpg";
import iconicImg from "../assets/Iconic-Leader.jpg";
import mobile30YearsImg from "../assets/mobile30yearsImg.jpg";
import mobile100YearsImg from "../assets/mobile100Awards.jpg";
import mobileIconicImg from "../assets/mobileIconicLeader.jpg";
import mobileAwardImg from "../assets/mobileAwardWinning.jpg";
import { Helmet } from "react-helmet";

export default function About() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        window.scrollTo({ top: element.offsetTop, behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div>
      <Helmet>
        <title>About Mother's Pride Preschool – Where Love Blossoms</title>
        <meta
          name="description"
          content="Discover the journey of Mother's Pride Preschool, a nurturing haven for young minds since 1996. With over 95 branches across India, we are dedicated to holistic child development through love, care, and a scientifically designed curriculum."
        />
        <link rel="canonical" href="https://www.motherspridepreschool.com/about" />
        <meta
          name="keywords"
          content="Nurturing preschool for toddlers , About us Mothers pride"
        />
      </Helmet>

      <div className="flex flex-col overflow-hidden w-full relative">
        <Who />
        <Vision />
        <Mission />

        {/* <div className="flex text-justify align-center flex-col font-Lato py-[20px] lg:py-[50px] bg-[#FAEDE7] px-[3%] lg:px-[8%]">
        <div className="flex">
          <p className=" text-[#000000] text-[40px] lg:text-[4rem]">
            Reshaping Education{" "}
            <span className=" text-[#D31C4F] text-[40px] lg:text-[4rem] ">
              Earliest
            </span>
          </p>
          <img src="rocket.svg" alt="" className="sm:flex hidden" />
        </div>

        <div className="flex text-justify sm:flex-row flex-col gap-[2rem] sm:gap-[4rem] justify-start sm:items-center sm:my-[10px] mt-[20px] sm:mt-[40px] ">
          <img src="teacher.svg" alt="" className="lg:h-full h-[300px]" />
          <p className="text-[#D31C4F] font-Lato sm:text-xl lg:text-2xl  font-medium leading-8 text-justify  sm:max-w-[70%]">
            "Our aim is to inspire a love of learning and help children develop
            the essential skills they need for a successful start in life. By
            fostering intellectual, social, and emotional growth, we ensure that
            every child in our care is ready to embark on their academic journey
            with confidence. We’re committed to providing a stimulating, safe,
            and inclusive environment where each child feels valued and
            supported."
          </p>
        </div>
      </div> */}

        <div>
          <div
            id="who"
            className="grid  sm:mt-[20px] lg:mt-[60px] relative overflow-hidden px-[3%] 2xl:px-[8%]"
          >
            <CustomHeading
              marginTop={"20px"}
              text={"Why"}
              textAlign="left"
              spanText={" Choose Us"}
              spanTextColor="#d31c4f"
              showHeart={true}
              smTextSize="33px"
            />

            <div className=" flex flex-between w-[100%] lg:h-[32.5rem] aboutPageCards mt-[20px] lg:mt-[60px]">
              <div className="w-[23%] bg-[#FFAFBB] relative  group h-[32.5rem] rounded-2xl lg:rounded-[3rem]  px-[1rem] py-[2rem]">
                <div className="group w-[95%] group-hover:opacity-35 h-1/2 left-[1%] lg:p-[20px] ">
                  <p className="text-[#D31C4F] text-[1.5rem] lg:text-[28px] font-bold lato text-4xl w-[80%]">
                    {" "}
                    30+ Years Legacy
                  </p>
                  <p className="text-xl text-[#5A5F9B] mt-4  lg:mt-[50px] w-[98%] pr-[3%] font-medium">
                    Mother’s Pride has revolutionized early years education and
                    has nurtured millions with love and learning.
                  </p>
                </div>
                <img
                  src={headingImg2}
                  alt="headingimg"
                  className="absolute bottom-[0px] 2xl:bottom-10 left-10 w-[60px] lg:w-[80px] 2xl:w-[100px] h-[100px] "
                />
                <img
                  src={window.innerWidth < 450 ? mobile30YearsImg : yearsImg}
                  alt="headingimg"
                  className="absolute top-0 h-full w-full rounded-lg lg:rounded-[3rem] left-0 transition-all duration-300 ease-in-out opacity-0 group-hover:opacity-100"
                />
              </div>
              <div className="relative group h-full bg-[#FFD5FF] rounded-2xl lg:rounded-[3rem] w-[23%]">
                <p
                  className={
                    "text-[1.5rem] lg:text-[28px] w-[100%] lg:w-[80%] text-[#D31C4F]  font-bold m-[10%] "
                  }
                >
                  100+ National
                  <br />
                  International
                  <br />
                  Awards
                </p>
                <div className="relative flex flex-col">
                  <p className="text-xl text-[#5A5F9B] font-medium mt-0 w-[99%] px-[10%]">
                    The pride, the passion and the pursuit of excellence is
                    unstoppable.
                  </p>
                </div>
                <img
                  src={headingImg4}
                  alt="headingimg"
                  className="absolute bottom-[-10%] lg:bottom-7 2xl:bottom-7 right-10 lg:right-5 2xl:right-0 lg:left-5 2xl:left-10  w-[60px] lg:w-[100px] 2xl:w-[140px] h-[180px] "
                />
                <img
                  src={window.innerWidth < 450 ? mobile100YearsImg : awardsImg}
                  alt="headingimg"
                  className="absolute top-0 h-full w-full rounded-lg lg:rounded-[3rem] left-0 transition-all duration-300 ease-in-out opacity-0 group-hover:shadow-md group-hover:opacity-100"
                />
              </div>
              <div className=" relative group h-full bg-[#e7dcff] rounded-2xl lg:rounded-[3rem] w-[23%]">
                <p
                  className={
                    "text-[1.5rem] lg:text-[28px] text-[#D31C4F] w-[70%] font-bold m-[10%] "
                  }
                >
                  Iconic Leader Ms. Sudha Gupta
                </p>
                <div>
                  <p className="text-xl text-[#5A5F9B] mt-4 w-[95%] px-[10%] font-medium">
                    She is recognized worldwide for transforming the education
                    system.
                  </p>
                </div>
                <img
                  src={headingImg}
                  alt="headingimg"
                  className="absolute w-[80px]  bottom-[-10%] lg:bottom-2  2xl:bottom-10 left-10 lg:w-[100px] 2xl:w-[140px] h-[180px] "
                />
                <img
                  src={window.innerWidth < 450 ? mobileIconicImg : iconicImg}
                  alt="headingimg"
                  className="absolute top-0 h-full w-full rounded-lg lg:rounded-[3rem] left-0 transition-all duration-300 ease-in-out opacity-0 group-hover:opacity-100"
                />
              </div>
              <div className="h-full relative group bg-[#C4DBFF] rounded-2xl lg:rounded-[3rem] w-[23%]">
                <p
                  className={
                    "text-[1.5rem] lg:text-[28px] w-[80%] text-[#D31C4F] font-bold m-[10%] "
                  }
                >
                  Award Winning
                  <br />
                  Philosophy &
                  <br />
                  Curriculum
                </p>
                <div>
                  <p className="text-xl text-[#5A5F9B] mt-0 w-[96%] font-medium px-[10%]">
                    Our Philosophy "Love Blossoms Here" & "The Curriculum of
                    Love" have been recognized on International Platforms
                  </p>
                </div>
                <img
                  src={headingIm3}
                  alt="headingimg"
                  className="absolute bottom-0 right-5 lg:left-5 2xl:left-10 w-[50px] lg:w-[80px] 2xl:w-[100px] h-[110px] "
                />
                <img
                  src={window.innerWidth < 450 ? mobileAwardImg : winningImg}
                  alt="headingimg"
                  className="absolute top-0 h-full w-full rounded-lg lg:rounded-[3rem] left-0 transition-all duration-300 ease-in-out opacity-0 group-hover:opacity-100"
                />
              </div>
            </div>
          </div>
          <Leader />
          {/* <MeetTeam /> */}
          <OurStory />
          <Awards />
          <Groups />
          <CustomFaqs type="Landing" />
          <GetInTouchFooter marginX={window?.innerWidth < 450 ? "4%" : "7%"} />
          <Footer marginX={"7%"} />
        </div>
      </div>
    </div>
  );
}
